import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ICampaign } from '@user/store/campaigns'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  label: string
  leadSourceRequired: boolean
  required: boolean
  show: boolean
  name: string
  density: DensityType
  disabled: boolean
}

export default function CampaignSelect(props: Props) {
  const { required, show, name, leadSourceRequired, disabled, ...rest } = props
  const { initialOption, isSubmitting, showError, helperText, ...restUseData } =
    useData({ required, name })
  const { handelChange, handelFocus, handelBlur } = useHandlers({
    name,
    required,
    leadSourceRequired,
  })

  return show ? (
    <Box>
      <Select<ICampaign>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        required={required}
        error={showError}
        disableClearOnBlur
        onChange={handelChange}
        value={initialOption}
        optionMode={'normal'}
        onFocus={handelFocus}
        onBlur={handelBlur}
        testId="campaign-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
